module.exports = __webpack_public_path__ + "static/media/cafe24-standoil3.4a784a92.png";